"use strict";
angular.module("userInformationServiceModule", [
    "createUserModule", //新建用户
    "roleSettingModule", //角色设置
    "userDetailsModule", //用户详细信息
    "importUserModule", //导入用户
    "resultDialogModule" //导入结果
]).
factory("userInformationService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [createProduct description] 新增/编辑用户
         * @param {[boolean]} [isCreate] [description] 是否是新增  true为新增 false为编辑
         * @param {[string]} [userId] [description] 用户ID
         */
        createUser: function(isCreate, userId) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/userInformation/service/createUser/createUser_tpl.html",
                windowClass: 'createUser backstageModalHeader',
                backdrop: false,
                controller: "createUserCtrl",
                resolve: {
                    userId: function() {
                        return userId;
                    },
                    isCreate: function() {
                        return isCreate;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },
        /**
         * [importUser description] 导入用户
         */
        importUser: function() {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/userInformation/service/importUser/importUser_tpl.html",
                windowClass: 'import-user backstageModalHeader',
                backdrop: false,
                controller: "importUserCtrl",
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },
        /**
         * [importResult description] 导入结果
         */
        importResult: function(result) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/userInformation/service/resultDialog/resultDialog_tpl.html",
                windowClass: 'result-dialog backstageModalHeader',
                backdrop: false,
                controller: "resultDialogCtrl",
                resolve: {
                    options: function() {
                        return result;
                    },
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },
        /**
         * [createProduct description] 角色设置
         * @param {[string]} [content] [description] 内容
         */
        roleSetting: function(userId) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/userInformation/service/roleSetting/roleSetting_tpl.html",
                windowClass: 'roleSetting backstageModalHeader',
                backdrop: false,
                controller: "roleSettingCtrl",
                resolve: {
                    userId: function() {
                        return userId;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },
        /**
         * [createProduct description] 用户详细信息
         * @param {[string]} [content] [description] 内容
         */
        userDetails: function(userId) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/userInformation/service/userDetails/userDetails_tpl.html",
                windowClass: 'userDetails backstageModalHeader',
                backdrop: false,
                controller: "userDetailsCtrl",
                resolve: {
                    userId: function() {
                        return userId;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },
    };
}]);